import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_KEY } from "../../../configurations/configurations";
import { baseUrlConfig } from "../../../configurations/configurations";

const { API_ROOT_URL } = baseUrlConfig.development;

export const mainApiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: API_ROOT_URL,
    prepareHeaders: (headers, { getState }) => {
      // il token dello store è memorizzato negli headers
      const token = getState().auth.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      if (API_KEY) {
        headers.set("X-API-Key", API_KEY);
      }
      return headers;
    },
  }),
  tagTypes: [],
  credentials: "include", // per includere i cookies nelle requests
  endpoints: (builder) => ({}),
});
